module.exports = __webpack_public_path__ + "static/media/CarlosJovel.add54599.jpg";